import React, { useContext } from 'react'
import styles from './leftbar.module.css'
import WhiteLogo from '../../../assets/WhiteLogo'

import IconList from './iconsList'
import { UserDataContext } from '../../../context/userData'

export default function ProfileBar() {

    const {userData}=useContext(UserDataContext);



    return (
        <div className={styles.pbContainer}>
            <div className={styles.pbinfo}>
            <WhiteLogo  style={{marginBottom:"20px",marginTop:"10px",width:"80px"}}/>
              <div className={styles.profileCard}>
                    <img src={`${userData.Profile_Image}`}/>
                    <div style={{fontWeight:"bold",color:"var(--primary-text-color)",marginTop:"2px"}}>{userData.Username}</div>
                   <div style={{fontSize:"smaller",marginTop:"-10px",textAlign:"center"}} >{userData.First_Name} | {userData.Title}</div>
                   <div className={styles.bio}>
                    {userData.Bio}
                    </div>
                 
                    <div style={{display:"flex"}}>
                        <div className={styles.fs}>
                           {userData.Followers}
                            <div>Followers</div>
                        </div>
                        <div className={styles.fs}>
                            {userData.Profile_Visit}
                            <div>Views</div>
                        </div>
                    </div> 
                    
                </div>
               
            </div>
            <div className={styles.iconseccon}>
            <div className={styles.iconsec}>
                <IconList/>
                 
                    </div> 
                    </div>
            
        </div>
    )
}
